import { render, staticRenderFns } from "./Pose3DEditor.vue?vue&type=template&id=550d670d&scoped=true"
import script from "./Pose3DEditor.vue?vue&type=script&lang=ts"
export * from "./Pose3DEditor.vue?vue&type=script&lang=ts"
import style0 from "./Pose3DEditor.vue?vue&type=style&index=0&id=550d670d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550d670d",
  null
  
)

export default component.exports